import * as React from "react";
function SvgIcPlus(props) {
  return <svg width="1em" height="1em" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}><path fillRule="evenodd" clipRule="evenodd" d="M6.417 6.417V1.459h1.166v4.958h4.959v1.167H7.583v4.958H6.417V7.584H1.458V6.417h4.959z" fill="currentColor" /></svg>;
}
export default SvgIcPlus;